module.exports = __webpack_public_path__ + "img/redeem-code.04a43e0a.svg";